<script setup lang="ts">
import Credit from "~/components/forms/Credit.vue";
import CreditAlt from "~/components/forms/CreditAlt.vue";
import StepCards from "~/components/static/StepCards.vue";
import BranchInfo from "~/components/static/BranchInfo.vue";
import HeaderV2 from "~/components/static/HeaderV2.vue";

const { locale: formLocale } = await useLocale("forms", null, true);
const { locale: homeLocale } = await useLocale("ui", null, true);

const emit = defineEmits(["submit"]);

const iconsCredit = computed(() => [
  {
    text: formLocale.value?.credit.icons.phone.text,
    icon: "Phone-blue",
  },
  {
    text: formLocale.value?.credit.icons.rata.text,
    icon: "RataFissa-blue",
  },
  {
    text: formLocale.value?.credit.icons.flash.text,
    icon: "Flash-blue",
  },
]);

const iconComponents = computed(() => {
  return iconsCredit.value.map((icon) => iconComponent(icon));
});

const creditForm: Component = useTemplateRef('credit-form');

const focusCreditSelect = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  setTimeout(() => {
    creditForm.value?.focusSelect();
  }, 400);
};

</script>

<template>
  <div class="bg-[#F0F0F0] -mt-[1px] bcp-home">
    <HeaderV2 :has-locale="false">
      <img
        src="@/themes/bcp/assets/img/logo.png"
        alt="Logo Banca di Credito Popolare"
        class="w-[153px] h-[70px]"
      />
    </HeaderV2>
    <Credit
      ref="credit-form"
      class="relative z-30 !mt-12 mb-16"
      :values="getCreditValues()"
      :cta-text="formLocale?.credit.labels.submit"
      :cta-subtext="formLocale?.credit.labels.ctaSubmit"
      @submit="emit('submit')"
    >
      <template #title
        ><span v-html="formLocale?.credit.title"></span
      ></template>
      <template #text
        ><span v-html="formLocale?.credit.subtitle"></span
      ></template>
      <template #icons>
        <div class="grid grid-cols-3 py-4 sm:py-4 lg:px-40 ">
          <div
            v-for="icon in iconComponents"
            :key="icon.text"
            class="text-center my-4"
          >
            <component
              :is="icon.icon"
              class="align-middle w-10 h-10 block rounded-full mb-1 sm:mt-0 inline-block"
            ></component>
            <h4 class=" block text-sm xl:inline-block lg:px-2 text-gray-5 w-full" v-html="icon.text"></h4>
          </div>
        </div>
      </template>
    </Credit>
    <!-- Banner-->
    <BranchInfo v-if="homeLocale" :info="homeLocale.home.branch_info" />

    <!-- Section steps -->
    <StepCards
      :cta="homeLocale?.home.section_steps.button_text"
      :steps="homeLocale?.home.section_steps.steps"
      @click="focusCreditSelect"
    >
      <template #title>
        <span>{{ homeLocale?.home.section_steps.title }}</span>
      </template>
    </StepCards>

    <!--  Credit alt form  -->
    <CreditAlt
      :cta-text="formLocale?.credit_alt.button.submit"
      :cta-subtext="formLocale?.credit_alt.button.ctaSubmit"
      :values="getCreditValues()"
      @submit="emit('submit')"
    >
      <template #title>
        <span class="text-3xl">{{ formLocale?.credit_alt.title }}</span>
      </template>
      <template #text>
        <span>{{ formLocale?.credit_alt.subtitle }}</span>
      </template>
      <template #helper_text>
        <span>{{ formLocale?.credit_alt.helper_text }}</span>
      </template>
    </CreditAlt>
  </div>
</template>
